import { theme as FooterTheme } from "../../../../theme/footerTheme";
import { customPalette } from "../../../../theme/theme";
import { CustomSubconfigurationNavigationButtons } from "../CustomSubconfigurationNavigationButtons/CustomSubconfigurationNavigationButtons";
import { FooterTextLabel } from "../FooterTextLabel/FooterTextLabel";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Footer } from "@4pace-cpq/core";
//import { CreateTemplateButton } from "../CreateTemplate/CreateTemplateButton";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { Container, ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
//import { useCsConfigurationApi } from "@plansoft-configuration-renderer/framework";
import { GatewayDest } from "@plansoft-configuration-renderer/gateway";
import { useNavigate, useSearch } from "@tanstack/react-router";

import { DownloadUserManualButton } from "./DownloadUserManualButton";
import { ExitConfigurationButton } from "./ExitConfigurationButton";

export function ConfigurationControls({
  showDownloadUserManual,
  onNextClicked,
  onPreviousClicked,
  nextDisabled,
  previousDisabled,
  onResetClicked,
}: {
  showDownloadUserManual: boolean;
  onNextClicked: () => void;
  onPreviousClicked: () => void;
  nextDisabled: boolean;
  previousDisabled: boolean;
  onResetClicked: () => void;
  resetDisabled: boolean;
}): JSX.Element {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { quoteId, configurationId /*itemGroupId*/ } = useSearch({
    strict: false,
  });

  //const { resetCurrentCfgObject } = useCsConfigurationApi();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {quoteId ? (
        <></>
      ) : (
        <Button
          variant="text"
          color="primary"
          startIcon={<ArrowLeftIcon />}
          onClick={() =>
            navigate({
              to: "/",
            })
          }
        >
          {t("WEG:buttons.backToRoot")}
        </Button>
      )}

      <ThemeProvider theme={FooterTheme}>
        <Footer>
          <Box
            sx={{
              display: "flex",
              background: customPalette.primary.dark,
            }}
          >
            <FooterTextLabel />

            <Container maxWidth={false}>
              <Box
                my={2}
                display="flex"
                justifyContent="space-between"
                marginX={"5rem"}
                alignItems="center"
              >
                <Box display="flex" gap={1} justifyContent="flex-start">
                  <GatewayDest name="configurator-footer-left" />

                  <CustomSubconfigurationNavigationButtons
                    onNextClicked={onNextClicked}
                    onPreviousClicked={onPreviousClicked}
                    nextDisabled={nextDisabled}
                    previousDisabled={previousDisabled}
                    onResetClicked={onResetClicked}
                    resetDisabled={false}
                  />
                </Box>
                <Box display="flex" gap={1} justifyContent="flex-end">
                  {showDownloadUserManual && <DownloadUserManualButton />}
                  <GatewayDest name="configurator-footer-right" />
                  <ExitConfigurationButton configurationId={configurationId} />
                </Box>
              </Box>
            </Container>
          </Box>
        </Footer>
      </ThemeProvider>
    </Box>
  );
}
